/**
 * Die Texte der Fehlerseiten — ein Auszug aus dem Wörterbuch, beim Bauen
 * mitgeliefert (`texte.generated.json`).
 *
 * Mitgeliefert, nicht abgerufen: Die Texte der App kommen aus der Datenbank
 * (`/api/i18n/translations/<sprache>`), und der häufigste Grund für diese Seite
 * ist, dass das Backend nicht antwortet — dann käme auch kein Text. Ein
 * Abruf beim Next-Server hälfe nicht: Der kennt das Wörterbuch selbst nur über
 * das Backend.
 *
 * Erzeugt aus der Endfassung der Migrationskette (`npm run texte:fehlerseiten`,
 * Quelle `backend/tests/fehlerseiten_texte.py`); `test_fehlerseiten_canon.py`
 * wird rot, wenn Auszug und Kette auseinanderlaufen oder ein Text fehlt. Was
 * die Verwaltung im Wörterbuch-Editor nachträglich ändert, sieht dieser Auszug
 * bis zum nächsten Erzeugen nicht — bewusst: Er gilt nur für die Fehlerseite.
 */
import AUSZUG from './texte.generated.json';

import type { FooterUebersetzer } from '../LegalFooterInhalt';

const TEXTE: Record<string, Record<string, string>> = AUSZUG;

/** Die Sprachen, für die der Auszug Texte trägt. */
export const SPRACHEN: readonly string[] = Object.keys(TEXTE);

/**
 * Übersetzer über den Auszug einer Sprache. Die deutsche Vorgabe des Aufrufs
 * wird NIE gezeigt — unter einer französischen Adresse wäre sie ein stiller
 * Fehler (Regel #7). Fehlt ein Text, steht der Schlüssel da, und es steht laut
 * im Log; der Wächter verhindert, dass das ausgeliefert wird.
 */
export function uebersetzer(sprache: string): FooterUebersetzer {
  const auszug = TEXTE[sprache];
  if (auszug === undefined) throw new Error(`Fehlerseite: kein Textauszug für „${sprache}“`);
  return (schluessel) => {
    const text = auszug[schluessel];
    if (text === undefined) {
      console.error(`Fehlerseite: Text fehlt im Auszug — ${sprache}/${schluessel}`);
      return schluessel;
    }
    return text;
  };
}
